import { mustStartEndLetterNumber } from './helper/ValidatorRules'

const mustStartEndLetterNumberValidator = {
  getMessage: () => 'Sorry, the value you have entered is invalid. Please enter a valid value that starts and ends with a letter or number.',
  validate: value => {
    return {
      valid: value === '' || mustStartEndLetterNumber(value),
      data: {
        required: true
      }
    }
  }
}

export default mustStartEndLetterNumberValidator
